import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import trainTime from '../../lib/TrainTime';


function DateTime ({ className, dateTime, format }) {
    return (
        <time className={ classnames('time', className) }
                dateTime={ dateTime && dateTime.toISOString() }>
            { dateTime && dateTime.format(format) }
        </time>
    );
}


DateTime.propTypes = {
    className: PropTypes.string,
    dateTime: PropTypes.object,
    format: PropTypes.string
};

DateTime.defaultProps = {
    dateTime: trainTime(),
    format: 'DD/MM/YYYY HH:mm'
};


export default DateTime;



// WEBPACK FOOTER //
// ./src/components/general/DateTime.js